import { PublishedResults } from '../../../components/results/shared/PublishedResults';

export default function StudentViewExam() {
  return <PublishedResults assessmentType="exam" audience="student" />;
}
